$(document).ready(function() {
  $(window).scroll(bindScroll);
});

function bindScroll() {
  var loadArticleUrl = $("#article-load-more").attr("data-article-load-url");
  var landingCards = $(".landing-cards");
  if (landingCards.length) {
    if (($(window).scrollTop() + $(window).height() >= $(".landing-cards").offset().top + $(".landing-cards").height()) && (loadArticleUrl)) {
      $("#article-loading").show();
      $(window).unbind("scroll");
      setTimeout(function() {
        loadMore(loadArticleUrl);
      }, 500);
    }
  }
}

function loadMore(loadArticleUrl) {
  $.ajax({
    url: loadArticleUrl,
    success: function(data) {
      var newPageElements = $(data).find("#article-append-load .article-card");
      $("#article-append-load").append(newPageElements);

      var nextPageUrl = $(data).find("#article-load-more").attr("data-article-load-url");
      if (nextPageUrl) {
        $("#article-load-more").attr("data-article-load-url", nextPageUrl);
      } else {
        $("#article-load-more").remove();
      }

      $("#article-loading").hide();
      $(window).bind("scroll", bindScroll);
    },
    cache: false,
  });
}
